import classNames from 'classnames';
import { FunctionComponent, ReactElement } from 'react';

import Text from '../../../common/components/text/Text';
import styles from './occurrenceInfo.module.scss';

export type InfoItemProps = {
  id: string;
  className?: string;
  icon: ReactElement;
  label: string;
  description?: string;
  fullWidth?: boolean;
};

const InfoItem: FunctionComponent<InfoItemProps> = ({
  id,
  className,
  icon,
  label = '',
  description = '',
  fullWidth = false,
}) => {
  return (
    <div
      id={id}
      className={classNames(className, { [styles.fullWidth]: fullWidth })}
    >
      {icon}
      <div>
        <Text variant="body" className={styles.label}>
          {label}
        </Text>

        {description && (
          <Text className={styles.description}>{description}</Text>
        )}
      </div>
    </div>
  );
};

export default InfoItem;
